// FILTER mutations
/* eslint-disable */
import types from '../../types';

export default {
  [types.OPEN_SIDEBAR]: (state) => {
    state.sidebar.isOpened = true;
  },
  [types.CLOSE_SIDEBAR]: (state) => {
    state.sidebar.isOpened = false;
  },
  [types.STORE_SIDEBAR_FIELDS]: (state, payload) => {
    state.sidebarFields = payload.sidebarFields;
    state.tableName = payload.sidebarTableName;
    state.tableApi = payload.tableApi;
    state.sidebarTableApi = payload.sidebarTableApi;
  },
  [types.CLEAR_SIDEBAR_FIELDS]: (state) => {
    state.sidebarFields = [];
  },
  [types.STORE_NEW_FILTER]: (state, payload) => {
    state.filtersMenu.push(payload);
  },
  [types.SET_IS_CUSTOM_FILTER_NAME]: (state, payload) => {
    state.customName = payload;
  },
  [types.SET_IS_NEW_FILTER]: (state, payload) => {
    state.isNewFilter = payload;
  },
  [types.STORE_FILTERS_MENU]: (state, payload) => {
    state.filtersMenu = payload;
  },
  [types.CLEAR_FILTERS_MENU]: (state) => {
    state.filtersMenu = [];
  },
  [types.STORE_ACTIVE_FILTER]: (state, payload) => {
    state.activeFilter = payload.params;
    state.activeFilterName = payload.name;
  },
  [types.CLEAR_ACTIVE_FILTER]: (state) => {
    state.activeFilter = {};
    state.activeFilterName = 'All';
  },
  [types.STORE_SEARCH]: (state, payload) => {
    state.search = payload;
  },
  [types.CLEAR_SEARCH]: (state) => {
    state.search = '';
  },
  [types.REMOVE_EXISTING_FILTER_PARAM]: (state, payload) => {
    // delete state.activeFilter.payload;
    // state.activeFilter = { ...state.activeFilter };
    let newStateObject = {};
    Object.keys(state.activeFilter).map(function(key, index) {
      if(key !== payload) {
        newStateObject[key] = state.activeFilter[key];
      }
    });
    state.activeFilter = { ...newStateObject };
  },
  [types.REMOVE_EXISTING_FILTER_ALL]: (state) => {
    state.activeFilter = {};
    state.activeFilterName = 'All';
  },
  [types.EDIT_EXISTING_FILTER]: (state, payload) => {
    state.filtersMenu = state.filtersMenu.map((filterItem) => {
      if(state.activeFilterName == filterItem.name) {
        return {
          name: payload.name,
          params: payload.params,
        }
      } else {
        return filterItem;
      }
    });
    state.activeFilterName = payload.name;
  },
  [types.STORE_ALLSHIPMENT_SEARCH_QUERY]: (state, payload) => {
    state.allShipmentSearchQuery = payload;
  },
  [types.DATA_NOT_FOUND]: (state, payload) => {
    state.dataNotFound = payload;
  },
  [types.RESET_DATA_NOT_FOUND]: (state, payload) => {
    //when component is mounted, when user change page we need to set dataNotFound to false
    state.dataNotFound = false;
  },
  // DOVDE JE DOBRO
};
